import React from "react";

import Logo from "../Parts/Logo";
import Hero from "../Parts/Hero";
import TagLine from "../Parts/TagLine";
import Meet from "../Parts/Meet";
import Footer from "../Parts/Footer";

const Home = () => {
  return (
    <div>
      <Logo />
      <Hero />
      <TagLine />
      <Meet />
      <Footer />
    </div>
  );
};

export default Home;
